import Overview from "../pages/oem/home/overview";
import Product from "../pages/oem/product/product-portfolio";
import ServiceSupport from "../pages/oem/service-support/create-ticket";
import Training from "../pages/oem/training/training-calender";
import Claims from "../pages/oem/claims";
import Contact from "../pages/oem/contact";
import Dashboard from "../pages/admin/dashboard";
import Setup from "../pages/admin/setup";
import Reports from "../pages/admin/reports";
import PastTickets from "../pages/admin/past-ticket";
import TicketDetailsV2 from "../pages/admin/ticket-details-v2";
import Milestones from "../pages/oem/home/milestones";
import FAQ from "../pages/oem/home/faq";
import PowerRange from "../pages/oem/product/power-range";
import WorkshopManual from "../pages/oem/literature/workshop-manual";
import ServiceInformation from "../pages/oem/literature/service-information";
import ServiceBulletins from "../pages/oem/literature/service-bulletins";
import CreateTicket from "../pages/oem/service-support/create-ticket";
import ServiceTicket from "../pages/oem/service-support/service-ticket";
import TrainingCalender from "../pages/oem/training/training-calender";
import FocForm from "../components/ticket-form/foc-form";
import CalendarMonth from "../components/financial-year-calendar/calendar-month";
import TrainingEnrollmentList from "../components/training-enrollment/training-enrollment-list";
import TrainingEnrollmentCertificate from "../components/training-enrollment/training-enrollment-certificate";
import TrainingRequestedList from "../components/training-enrollment/training-request-list";
import TrainingReport from "../pages/oem/training/training-report";
import TrainingApprovalStatus from "../pages/oem/training/training-approval-status";
import TrainingApprovalAdmin from "../pages/oem/training/training-approval-status/training-approval-admin";
import TrainingRequestedListOEM from "../components/training-enrollment/training-request-list-oem";
import FloatEngineMovements from "../pages/admin/float-engine-movements";
import FloatEngineDetails from "../pages/admin/float-engine-movements/float-engine-details";
import FloatEngineInward from "../pages/admin/ticket-details-v2/float-engine-Inward";
import AdvanceEngineReplacementForm from "../pages/admin/ticket-details-v2/advance-engine-replacement-form";
import WorkshopManualAdmin from "../pages/admin/literature/workshop-manuals";
import JointInspectionReport from "../pages/admin/ticket-details-v2/joint-inspection-report";
import ViewFoc from "../pages/admin/float-engine-movements/view-foc";
import ServiceInformationAdmin from "../pages/admin/literature/service-information";
import ServiceBulletinsAdmin from "../pages/admin/literature/service-bulletins";
import InternalCutInAdmin from "../pages/admin/literature/internal-cutin";
import FaqAdmin from "../pages/admin/literature/faq";
import FailedEngineAnalysis from "../pages/admin/analysis/failed-engine-analysis";
import FailedPartsAnalysis from "../pages/admin/analysis/failed-parts-analysis";
import ICA from "../pages/admin/analysis/ICA";
import InvoiceEngineDetails from "../pages/admin/analysis/invoice-engine-details";
import PendingRequests from "../pages/admin/pending-requests";
import FloatEngines from "../pages/admin/float-engines";
import EngineerMovements from "../pages/admin/enginner-movement";
import AdminWarrantyClaims from "../pages/admin/warranty-claims";
import SapClaims from "../pages/admin/warranty-claims/sap-claims";
import QualityApproverPendingRequests from "../pages/admin/quality-approver-pending-requests";
import InfantCareTracking from "../pages/admin/analysis/infant-care";
import BenchMarking from "../pages/admin/analysis/bench-marking";
import StockDetails from "../pages/admin/stock-details";
import TrainingCertificateOem from "../pages/oem/training/training-certificate/training-certificate-oem";
import EngineReplacementTrend from "../pages/admin/dashboard/engine-replacement-trend";
import TrainingDashboard from "../pages/admin/dashboard/training-dashboard";
import OemHoDashboard from "../pages/oem/ho-dashboard";
import Mis from "../components/overview/mis";
import TrainingMonthEnrollment from "../pages/oem/training/training-month-enrollment";
import TrainingMonthEnrollmentAdmin from "../pages/oem/training/training-month-enrollment/training-month-enrollment-admin";
import FloatEngineDashboard from "../pages/admin/dashboard/float-engine-dashboard";
import PartsCatalouge from "../pages/oem/parts-catalouge";
import ExportEngineTracking from "../pages/admin/export-engine-tracking";
import EventCalendar from "../components/schedule-event";
import EventMonthEnrollment from "../components/schedule-event/upcoming-event-enrollment";
import TrainingPlanVsActual from "../pages/admin/training-plan-vs-actual";
import KnowledgeSharing from "../pages/admin/knowledge-sharing";
import OemEventCalendar from "../components/oem-events";
import TrainingModule from "../pages/admin/training-module";
import OemTrainingModule from "../pages/oem/training-module";

export const OEM_ROUTES = [
  { path: "/oem", component: <Overview /> },
  { path: "/oem/milestones", component: <Milestones /> },
  { path: "/oem/faq", component: <FAQ /> },
  { path: "/oem/dashboard", component: <OemHoDashboard /> },
  { path: "/oem/parts-catalogue", component: <PartsCatalouge /> },

  { path: "/oem/products", component: <Product /> },
  { path: "/oem/products/power-range", component: <PowerRange /> },

  { path: "/oem/literature/workshop-manual", component: <WorkshopManual /> },
  { path: "/oem/literature/service-info", component: <ServiceInformation /> },
  {
    path: "/oem/literature/service-bulletins",
    component: <ServiceBulletins />,
  },

  { path: "/oem/create-ticket", component: <CreateTicket /> },
  { path: "/oem/service-support", component: <ServiceTicket /> },

  { path: "/oem/training/training-year-view", component: <TrainingCalender /> },
  {
    path: "/oem/training/training-calendar-view",
    component: <CalendarMonth />,
  },
  {
    path: "/oem/training/training-enrollment-list",
    component: <TrainingEnrollmentList />,
  },
  {
    path: "/oem/training/training-requested-list",
    component: <TrainingRequestedList />,
  },
  {
    path: "/oem/training/training-enrollment-certificate",
    component: <TrainingEnrollmentCertificate />,
  },
  { path: "/oem/training-certificates", component: <TrainingCertificateOem /> },
  {
    path: "/oem/training/training-approval-status",
    component: <TrainingApprovalStatus />,
  },
  {
    path: "/oem/training/training-request-details",
    component: <TrainingRequestedListOEM />,
  },
  {
    path: "/oem/training/training-month-enrollment-view",
    component: <TrainingMonthEnrollment />,
  },
  { path: "/oem/jir/:id", component: <JointInspectionReport /> },

  { path: "/oem/claims", component: <Claims /> },
  { path: "/oem/contacts", component: <Contact /> },
  { path: "/oem/foc-form/:ticketId", component: <FocForm /> },
  { path: "/oem/schedule-event", component: <OemEventCalendar /> },
  {
    path: "/oem/training/event-month-enrollment-view",
    component: <EventMonthEnrollment />,
  },
  {
    path: "/oem/training/training-module",
    component: <OemTrainingModule />,
  },
];

export const ADMIN_ROUTES = [
  { path: "/admin", component: <Dashboard /> },
  // { path: "/admin/dashboard", component: <Dashboard /> },
  {
    path: "/admin/engine-replacement-trend",
    component: <EngineReplacementTrend />,
  },
  {
    path: "/admin/mis",
    component: <Mis />,
  },
  { path: "/admin/training-dashboard", component: <TrainingDashboard /> },

  { path: "/admin/setup", component: <Setup /> },
  // { path: "/admin/reports", component: <Reports /> },
  { path: "/admin/tickets", component: <PastTickets /> },
  { path: "/admin/float-engine-movement", component: <FloatEngineMovements /> },
  { path: "/admin/float-engines", component: <FloatEngines /> },
  { path: "/admin/schedule-event", component: <EventCalendar /> },
  { path: "/admin/knowledge-sharing", component: <KnowledgeSharing /> },

  { path: "/admin/wsm", component: <WorkshopManualAdmin /> },
  { path: "/admin/service-info", component: <ServiceInformationAdmin /> },
  { path: "/admin/service-bulletins", component: <ServiceBulletinsAdmin /> },
  { path: "/admin/internal-cutin", component: <InternalCutInAdmin /> },
  { path: "/admin/faq", component: <FaqAdmin /> },
  {
    path: "/admin/failed-engine-analysis",
    component: <FailedEngineAnalysis />,
  },
  { path: "/admin/failed-part-analysis", component: <FailedPartsAnalysis /> },
  { path: "/admin/ica", component: <ICA /> },
  { path: "/admin/invoice-engine-details", component: <InvoiceEngineDetails /> },
  { path: "/admin/pending-requests", component: <PendingRequests /> },
  {
    path: "/admin/quality-pending-requests",
    component: <QualityApproverPendingRequests />,
  },
  { path: "/admin/warranty-claims", component: <AdminWarrantyClaims /> },
  { path: "/admin/infant-care-tracking", component: <InfantCareTracking /> },
  { path: "/admin/bench-marking", component: <BenchMarking /> },

  { path: "/admin/sap-claims", component: <SapClaims /> },
  { path: "/admin/details/:id", component: <TicketDetailsV2 /> },
  { path: "/admin/engineer-movement", component: <EngineerMovements /> },
  {
    path: "/admin/export-engine-tracking",
    component: <ExportEngineTracking />,
  },

  {
    path: "/admin/training/training-year-view",
    component: <TrainingCalender />,
  },
  {
    path: "/admin/training/training-module",
    component: <TrainingModule />,
  },
  {
    path: "/admin/training/training-calendar-view",
    component: <CalendarMonth />,
  },
  {
    path: "/admin/training/training-enrollment-list",
    component: <TrainingEnrollmentList />,
  },
  {
    path: "/admin/training/training-requested-list",
    component: <TrainingRequestedList />,
  },
  {
    path: "/admin/training/training-enrollment-certificate",
    component: <TrainingEnrollmentCertificate />,
  },
  {
    path: "/admin/training/training-approval",
    component: <TrainingApprovalAdmin />,
  },
  {
    path: "/admin/training/training-plan-vs-actual",
    component: <TrainingPlanVsActual />,
  },
  {
    path: "/admin/training/training-month-enrollment-view",
    component: <TrainingMonthEnrollmentAdmin />,
  },
  {
    path: "/admin/training/event-month-enrollment-view",
    component: <EventMonthEnrollment />,
  },
  { path: "/admin/training-reports", component: <TrainingReport /> },
  { path: "/admin/jir/:id", component: <JointInspectionReport /> },
  { path: "/admin/view-foc/:id", component: <ViewFoc /> },
  { path: "/admin/float-engine/:id", component: <FloatEngineDetails /> },
  { path: "/admin/float-engine-Inward", component: <FloatEngineInward /> },
  { path: "/admin/stock-details", component: <StockDetails /> },
  {
    path: "/admin/float-engine-dashboard",
    component: <FloatEngineDashboard />,
  },

  {
    path: "/admin/advance-engine-replacement",
    component: <AdvanceEngineReplacementForm />,
  },
];
